import { ElementRef, QueryList } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import type SdInput from '@solid-design-system/components/dist-versioned/components/input/input';
import { RelevantUserInfo, UserInfoInputCombinedRequirement } from './user-info-input-fields';

export class CombinedRequiredInputChecker {
  constructor(
    private readonly transloco: TranslocoService,
  ) {}

  public checkCombinedInputValidity(state: RelevantUserInfo, allInputElements: QueryList<ElementRef<SdInput>>, combinedRequiredInputs: ReadonlyArray<UserInfoInputCombinedRequirement> | undefined): boolean {
    if (!combinedRequiredInputs || combinedRequiredInputs.length === 0) {
      return true;
    }

    let allValid: boolean = true;

    for (const combinedRequiredInput of combinedRequiredInputs) {
      const affectedInputElements: ElementRef<SdInput>[] = this.getAffectedInputElements(combinedRequiredInput, allInputElements);

      const valid: boolean = this.checkAffectedInputElementValidity(state, affectedInputElements);

      if (valid) {
        this.clearCombinedInputError(affectedInputElements);
        continue;
      }

      allValid = false;

      this.applyCombinedInputError(combinedRequiredInput, affectedInputElements);
    }

    return allValid;
  }

  private getAffectedInputElements(combinedRequiredInput: UserInfoInputCombinedRequirement, allInputElements: QueryList<ElementRef<SdInput>>) {
    return allInputElements.filter(inputElement =>
      combinedRequiredInput.keys.some(key => inputElement.nativeElement.getAttribute('key') === key)
    );
  }

  private checkAffectedInputElementValidity(state: RelevantUserInfo, affectedInputElements: ElementRef<SdInput>[]): boolean {
    for (const inputElement of affectedInputElements) {
      const key = inputElement.nativeElement.getAttribute('key') as keyof RelevantUserInfo;
      const value: string | undefined = state[key];

      if (value && value.length > 0) {
        return true;
      }
    }

    return false;
  }

  private clearCombinedInputError(affectedInputElements: ElementRef<SdInput>[]): void {
    for (const inputElement of affectedInputElements) {
      inputElement.nativeElement.setCustomValidity('');
      inputElement.nativeElement.requestUpdate();
    }
  }

  private applyCombinedInputError(combinedRequiredInput: UserInfoInputCombinedRequirement, affectedInputElements: ElementRef<SdInput>[]): void {
    const message: string = this.transloco.translate(combinedRequiredInput.errorI18n);
    for (const inputElement of affectedInputElements) {
      inputElement.nativeElement.setCustomValidity(message)
      inputElement.nativeElement.requestUpdate();
    }
  }
}
